module.exports = __webpack_public_path__ + "img/txt.50738d31.svg";